import { combineReducers } from 'redux';

import filters from './filters';
import ids from './ids';
import links from './links';
import page from './page';

export default combineReducers({
  ids,
  page,
  links,
  filters,
});
